import {
  PolicyContainer,
  PolicyTitle,
  PolicyText,
  PolicyList,
  PolicySectionTitle,
  PolicyHyphenList,
} from "styles/PolicyCommon";
import { useEffect } from "react";

const HealthEn = () => {
  useEffect(() => {
    document.documentElement.lang = "en";
    document.title = "pregnancy&baby";
    return () => {
      document.documentElement.lang = "en";
      document.title = "pregnancy&baby";
    };
  }, []);

  return (
    <PolicyContainer>
      <h1 className="hide">pregnancy&amp;baby</h1>
      <PolicyTitle>
        Consent to the Collection and Use of Health Information
      </PolicyTitle>

      <PolicyText>
        You may choose whether to consent to the collection and use of health
        information when creating your account. Your consent is optional and is
        not required to create a pregnancy&baby account. However, if you do not
        consent, you may not be able to use features that require the processing
        of health information.
      </PolicyText>

      <PolicySectionTitle>1. Purposes of Collection and Use</PolicySectionTitle>
      <PolicyHyphenList>
        <li>
          To provide tracking and management features related to pregnancy
          preparation, fertility treatment, pregnancy, and child care
        </li>
        <li>
          To provide personalized features selected by you, including menstrual
          and ovulation predictions, pregnancy progress calculations, test
          result analysis, fetal growth analysis, and child growth and
          development analysis
        </li>
        <li>
          To provide health, pregnancy, and child-care reminders and information
          based on your settings
        </li>
      </PolicyHyphenList>

      <PolicySectionTitle>2. Health Information We Collect</PolicySectionTitle>
      <PolicyList>
        <li>
          <strong>[Pregnancy Preparation]</strong>
          <br />
          Menstrual period and cycle information, last menstrual period,
          menstrual start and end dates, ovulation date, ovulation test date and
          time, images and results, pregnancy test date and time, images and
          results, basal body temperature, symptoms, pain and bleeding records,
          sexual activity records, medication records, vaccination records,
          medical appointment records, and other health-related information you
          choose to record
        </li>
        <li>
          <strong>[Fertility Treatment]</strong>
          <br />
          Type of fertility treatment, treatment cycle, treatment start and end
          dates, medication and injection records, treatment schedules, and
          treatment details
        </li>
        <li>
          <strong>[Pregnancy]</strong>
          <br />
          Estimated due date, gestational age, medical appointment records,
          vaccination records, weight records, ultrasound images, fetal
          measurements (EFW/AC/FL/BPD/HC/CRL), pre-pregnancy height and weight,
          and other pregnancy-related information you choose to record
        </li>
        <li>
          <strong>[Child Care]</strong>
          <br />
          Child's date of birth, birth height, weight and head circumference,
          growth measurements, developmental assessment records and scores,
          development-related photos, premature birth information, health
          screening records, vaccination records, body temperature records,
          medication records, and illness records
        </li>
      </PolicyList>

      <PolicySectionTitle>3. Retention and Use Period</PolicySectionTitle>
      <PolicyText>
        When you delete a saved record, the information associated with that
        record will be deleted. When you delete your account, Personal Data that
        can identify you will be deleted. However, certain data generated
        through your use of the Services may be retained indefinitely for
        research, statistical analysis, and service improvement after being
        irreversibly anonymized so that you can no longer be identified.
        Anonymized data cannot be linked back to your account or Personal Data.
      </PolicyText>

      <PolicySectionTitle>Your Right to Decline Consent</PolicySectionTitle>
      <PolicyText>
        Your consent is optional, and you may create and use a pregnancy&baby
        account without providing this consent. However, if you do not consent,
        you may not be able to use features that require the processing of
        health information, including pregnancy preparation, fertility
        treatment, pregnancy, and child-care tracking features.
      </PolicyText>
    </PolicyContainer>
  );
};

export default HealthEn;
